export const Processing = 0;
export const Error = 1;
export const Duplicated = 2;
export const Processed = 3;